<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
            <a class="navbar-brand" href="#">
                <span class="brand-mark">
                    <img :src="logo" alt="Logotipo de Funko Pop Morelia">
                </span>
                <span class="brand-text">Funko Pop Morelia</span>
            </a>
            <div class="nav-socials nav-socials-mobile" aria-label="Redes sociales">
                <a
                    class="nav-social-link nav-social-link-instagram"
                    href="https://www.instagram.com/funkopopmorelia"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram de Funko Pop Morelia"
                >
                    <i class="fab fa-instagram" aria-hidden="true"></i>
                </a>
                <a
                    class="nav-social-link nav-social-link-facebook"
                    href="https://www.facebook.com/funkoPopMorelia"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Facebook de Funko Pop Morelia"
                >
                    <i class="fab fa-facebook-f" aria-hidden="true"></i>
                </a>
                <a
                    class="nav-social-link nav-social-link-whatsapp"
                    href="https://wa.me/524431104022"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="WhatsApp de Funko Pop Morelia"
                >
                    <i class="fab fa-whatsapp" aria-hidden="true"></i>
                </a>
            </div>
            <button
                class="navbar-toggler"
                type="button"
                aria-controls="mobileMenu"
                :aria-expanded="menuAbierto ? 'true' : 'false'"
                aria-label="Toggle navigation"
                @click="alternarMenu"
            >
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="navbar-collapse desktop-menu" id="navbarScroll">
                <ul class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll" style="--bs-scroll-height: 100px;">
                    <li class="nav-item">
                        <router-link to="/" @click="cerrarMenu">Catálogo</router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link to="/puntosEntrega">Puntos de Entrega</router-link>
                    </li> -->
                    <li class="nav-item d-none">
                        <router-link to="/encuestas" @click="cerrarMenu">Encuestas</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/descuentos" @click="cerrarMenu">Descuentos</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/promo-200" @click="cerrarMenu">Promoción</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/preventas" @click="cerrarMenu">Preventas</router-link>
                    </li>
                </ul>
                <div class="nav-socials nav-socials-desktop" aria-label="Redes sociales">
                    <a
                        class="nav-social-link nav-social-link-instagram"
                        href="https://www.instagram.com/funkopopmorelia"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Instagram de Funko Pop Morelia"
                    >
                        <i class="fab fa-instagram" aria-hidden="true"></i>
                    </a>
                    <a
                        class="nav-social-link nav-social-link-facebook"
                        href="https://www.facebook.com/funkoPopMorelia"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Facebook de Funko Pop Morelia"
                    >
                        <i class="fab fa-facebook-f" aria-hidden="true"></i>
                    </a>
                    <a
                        class="nav-social-link nav-social-link-whatsapp"
                        href="https://wa.me/524431104022"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="WhatsApp de Funko Pop Morelia"
                    >
                        <i class="fab fa-whatsapp" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>
    </nav>

    <button
        v-if="menuAbierto"
        class="menu-backdrop"
        type="button"
        aria-label="Cerrar menú"
        @click="cerrarMenu"
    ></button>

    <aside id="mobileMenu" class="mobile-menu-panel" :class="{ 'show': menuAbierto }" aria-label="Menú móvil">
        <div class="menu-panel-header">
            <span>Menú</span>
            <button type="button" class="menu-close" aria-label="Cerrar menú" @click="cerrarMenu">
                &times;
            </button>
        </div>
        <ul class="mobile-menu-list">
            <li class="nav-item">
                <router-link to="/" @click="cerrarMenu">Catálogo</router-link>
            </li>
            <li class="nav-item d-none">
                <router-link to="/encuestas" @click="cerrarMenu">Encuestas</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/descuentos" @click="cerrarMenu">Descuentos</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/promo-200" @click="cerrarMenu">Promoción</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/preventas" @click="cerrarMenu">Preventas</router-link>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
   
    data(){
        return{
            //logo: require("@/assets/funko-morelia-logo.jpeg")
            logo: require("@/assets/funko-morelia-logo.jpeg"),
            menuAbierto: false
        }
    },
    methods: {
        alternarMenu(){
            this.menuAbierto = !this.menuAbierto;
        },
        cerrarMenu(){
            this.menuAbierto = false;
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .navbar {
        background:
            linear-gradient(90deg, rgba(5, 6, 7, 0.72), rgba(10, 12, 14, 0.78)),
            url("~@/assets/header-assets/noise.svg"),
            #050607 !important;
        background-position: center, center;
        background-repeat: no-repeat, repeat;
        background-size: auto, auto;
        backdrop-filter: blur(14px);
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        box-shadow: 0 18px 40px rgba(0, 0, 0, 0.24);
        margin-bottom: 16px;
        overflow: hidden;
        padding: 0.8rem 0;
        position: sticky;
        top: 0;
        z-index: 1040;
        &:before,
        &:after{
            background: url("~@/assets/header-assets/brush4.webp") center / contain no-repeat;
            content: "";
            height: 220%;
            opacity: 0.28;
            pointer-events: none;
            position: absolute;
            top: 50%;
            width: min(48vw, 34rem);
            z-index: 0;
        }
        &:before{
            left: -4rem;
            transform: translateY(-50%);
        }
        &:after{
            right: -4rem;
            transform: translateY(-50%) scaleX(-1);
        }
       
        .router-link-exact-active {
            color: #ffffff;
            &:after{
                opacity: 1;
                transform: scaleX(1);
            }
        }
        .container-fluid{
            gap: 0.75rem;
            padding-left: 1rem;
            padding-right: 1rem;
            position: relative;
            z-index: 1;
        }
        &-brand {
            align-items: center;
            color: #ffffff;
            display: inline-flex;
            flex: 0 0 auto;
            gap: 0.75rem;
            line-height: 1;
            margin-right: 0;
            min-width: 0;
            text-decoration: none;
            .brand-mark{
                align-items: center;
                border-radius: 50%;
                box-shadow: 0 0 22px rgba(23, 139, 205, 0.18);
                display: inline-flex;
                flex-shrink: 0;
                height: 52px;
                justify-content: center;
                overflow: hidden;
                width: 52px;
                img {
                    border-radius: 50%;
                    height: 100%;
                    object-fit: contain;
                    object-position: center;
                    transform: scale(0.96);
                    width: 100%;
                }
            }
            .brand-text{
                color: #ffffff;
                display: inline-block;
                font-size: 1.15rem;
                font-weight: 800;
                letter-spacing: 0.01em;
                white-space: nowrap;
                @media (max-width: 430px){
                    display: none;
                }
            }
        }
        .nav-item{
            margin: 0;
            position: relative;
            a{
                align-items: center;
                color: rgba(255, 255, 255, 0.78);
                display: inline-flex;
                font-size: 1.2rem;
                font-weight: 500;
                justify-content: center;
                line-height: 1;
                min-height: 38px;
                padding: 0.45rem 0;
                position: relative;
                text-decoration: none;
                text-transform: none;
                transition: color 180ms ease, opacity 180ms ease;
                &:hover,
                &:focus{
                    color: #ffffff;
                }
                &:after{
                    background: #178bcd;
                    border-radius: 999px;
                    bottom: 0.18rem;
                    content: "";
                    height: 2px;
                    left: 0;
                    opacity: 0;
                    position: absolute;
                    right: 0;
                    transform: scaleX(0.4);
                    transform-origin: center;
                    transition: opacity 180ms ease, transform 180ms ease;
                }
                &:hover:after,
                &:focus:after{
                    opacity: 1;
                    transform: scaleX(1);
                }
            }
        }
    }

    .navbar-toggler{
        border-color: rgba(255, 255, 255, 0.32);
        margin-left: 0;
        &:focus{
            box-shadow: 0 0 0 0.2rem rgba(23, 139, 205, 0.25);
        }
    }

    .navbar-collapse{
        justify-content: center;
    }

    .mobile-menu-panel{
        display: none;
    }

    .navbar-nav{
        align-items: center;
        gap: clamp(0.85rem, 1.7vw, 1.5rem);
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
    }

    .nav-socials{
        align-items: center;
        display: inline-flex;
        gap: 1rem;
        margin-left: 0;
    }

    .nav-socials-mobile{
        display: none;
    }

    .nav-social-link{
        align-items: center;
        border-radius: 50%;
        color: #ffffff;
        display: inline-flex;
        font-size: 1.25rem;
        height: 2.2rem;
        justify-content: center;
        text-decoration: none;
        transition: transform 180ms ease, filter 180ms ease;
        width: 2.2rem;
        &:hover,
        &:focus{
            color: #ffffff;
            filter: brightness(1.05);
            transform: translateY(-1px);
        }
    }

    .nav-social-link-instagram{
        background: linear-gradient(135deg, #f9ce34 0%, #ee2a7b 52%, #6228d7 100%);
    }

    .nav-social-link-facebook{
        background: linear-gradient(180deg, #1877f2 0%, #0d5fd3 100%);
    }

    .nav-social-link-whatsapp{
        background: linear-gradient(180deg, #25d366 0%, #128c4a 100%);
    }

    .menu-panel-header,
    .menu-backdrop{
        display: none;
    }

    @media (min-width: 992px){
        .navbar{
            .navbar-collapse{
                align-items: center;
                display: flex !important;
            }
            .navbar-collapse,
            .navbar-nav{
                overflow: visible;
            }

            .dropdown-menu,
            .submenu,
            .sub-menu{
                background: #212529;
                border: 0;
                border-radius: 6px;
                box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
                left: auto;
                margin-top: 0;
                max-width: calc(100vw - 24px);
                min-width: 220px;
                padding: 8px;
                position: absolute;
                right: 0;
                top: 100%;
                z-index: 1060;
            }

            .dropdown-menu::before,
            .submenu::before,
            .sub-menu::before{
                content: "";
                height: 12px;
                left: 0;
                position: absolute;
                right: 0;
                top: -12px;
            }

            .dropdown-menu .dropdown-menu,
            .submenu .submenu,
            .sub-menu .sub-menu{
                margin-right: 6px;
                right: 100%;
                top: 0;
            }

            .dropdown:hover > .dropdown-menu,
            .dropdown:focus-within > .dropdown-menu,
            .has-submenu:hover > .submenu,
            .has-submenu:focus-within > .submenu,
            .has-submenu:hover > .sub-menu,
            .has-submenu:focus-within > .sub-menu{
                display: block;
            }
        }
    }

    @media (max-width: 991.98px){
        .navbar{
            position: sticky;
            &:before,
            &:after{
                height: 190%;
                opacity: 0.24;
                width: 22rem;
            }
            &:before{
                left: -9rem;
            }
            &:after{
                right: -9rem;
            }

            .container-fluid{
                align-items: center;
                position: relative;
            }

            .desktop-menu{
                display: none;
            }
        }

        .nav-socials-desktop{
            display: none;
        }

        .nav-socials-mobile{
            display: inline-flex;
            gap: 0.5rem;
            margin-left: auto;
        }

        .nav-social-link{
            font-size: 0.95rem;
            height: 2rem;
            width: 2rem;
        }

        .menu-backdrop{
            background: rgba(0, 0, 0, 0.45);
            border: 0;
            display: block;
            inset: 0;
            padding: 0;
            position: fixed;
            z-index: 1100;
        }

        .mobile-menu-panel{
            background:
                linear-gradient(90deg, rgba(5, 6, 7, 0.96), rgba(10, 12, 14, 0.98)),
                url("~@/assets/header-assets/noise.svg"),
                #050607;
            background-position: center;
            background-repeat: repeat;
            background-size: auto;
            bottom: 0;
            box-shadow: -8px 0 24px rgba(0, 0, 0, 0.22);
            display: block;
            max-width: 320px;
            opacity: 0;
            padding: 18px 18px 28px;
            pointer-events: none;
            position: fixed;
            right: 0;
            top: 0;
            transform: translateX(100%);
            transition: transform 0.24s ease, opacity 0.24s ease;
            width: 82vw;
            z-index: 1101;

            &.show{
                opacity: 1;
                pointer-events: auto;
                transform: translateX(0);
            }
        }

        .menu-panel-header{
            align-items: center;
            border-bottom: 1px solid rgba(255, 255, 255, 0.16);
            color: #FFF;
            display: flex;
            font-size: 16px;
            font-weight: 700;
            justify-content: space-between;
            margin-bottom: 14px;
            padding-bottom: 12px;
            text-transform: uppercase;
        }

        .menu-close{
            align-items: center;
            background: rgba(255, 255, 255, 0.12);
            border: 0;
            border-radius: 50%;
            color: #FFF;
            display: inline-flex;
            font-size: 18px;
            font-weight: 700;
            height: 34px;
            justify-content: center;
            line-height: 1;
            padding: 0;
            width: 34px;
        }

        .mobile-menu-list{
            display: grid;
            gap: 6px;
            list-style: none;
            margin: 0;
            padding: 0;
        }

        .mobile-menu-list .nav-item{
            margin: 0;
        }

        .mobile-menu-list a{
            border-radius: 6px;
            color: #FFF;
            display: block;
            font-size: 0.95rem;
            font-weight: 600;
            padding: 12px 10px;
            text-decoration: none;

            &.router-link-exact-active{
                background: rgba(255, 255, 255, 0.12);
            }
        }
    }
</style>
